import * as Location from 'expo-location';

/** `Location.getCurrentPositionAsync` has no built-in timeout — indoors or
 * with a weak GPS signal it can hang for minutes with zero feedback, which
 * looks exactly like a broken/unresponsive button. Race it against a timeout
 * so a bad fix always surfaces as a clear error instead of an endless spinner. */
export async function getCurrentPositionWithTimeout(
  options: Location.LocationOptions,
  timeoutMs = 15000,
): Promise<Location.LocationObject> {
  return Promise.race([
    Location.getCurrentPositionAsync(options),
    new Promise<Location.LocationObject>((_, reject) =>
      setTimeout(
        () => reject(new Error('Không bắt được tín hiệu định vị sau 15 giây — hãy ra ngoài trời hoặc gần cửa sổ rồi thử lại.')),
        timeoutMs,
      ),
    ),
  ]);
}
